import { Component, input, model } from '@angular/core';

@Component({
	selector: 'app-dialog-selection-bar',
	templateUrl: './dialog-selection-bar.component.html',
	styleUrls: ['./dialog-selection-bar.component.scss'],
})
export class DialogSelectionBarComponent<T> {
	readonly selection = model.required<T>();

	readonly selections = input<T[]>([]);
}
